export default function stateId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return state + 1;
}


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/dist/esm/reducers/stateId.js
// module id = 790
// module chunks = 4